import { ChangeDetectorRef, Component } from '@angular/core';
import { ImportsModule } from "../../shared/imports.module";
import { Solicitud, Usuario } from '../../shared/models';
import { CommonModule, CurrencyPipe, DatePipe, SlicePipe } from '@angular/common';
import { GestionSgmmService } from '../../shared/services/gestion-sgmm.service';
import { NzDrawerService } from 'ng-zorro-antd/drawer';
import { EnvioSolicitudesComponent } from '../../shared/components/envio-solicitudes/envio-solicitudes.component';
import { DetalleSolicitudComponent } from '../../shared/components/detalle-solicitud/detalle-solicitud.component';
import { saveAs } from 'file-saver';
import { finalize, lastValueFrom, Subject, takeUntil } from 'rxjs';
import { PerfilStore } from '../../shared/store/perfil.store';
import { Router } from '@angular/router';
import { CatalogosService } from '../../shared/services/catalogos.service';
@Component({
  selector: 'app-gestion-sgmm',
  standalone: true,
  imports: [ImportsModule, CommonModule, CurrencyPipe, DatePipe, SlicePipe],
  templateUrl: './gestion-sgmm.component.html',
  styleUrl: './gestion-sgmm.component.scss'
})
export class GestionSgmmComponent {

  constructor(
    private gestionSgmmService: GestionSgmmService,
    private drawerService: NzDrawerService,
    private sessionStore: PerfilStore,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private catalogos: CatalogosService
  ) { }
  user ?: Usuario | null = {};
  $onDestroy: any = new Subject<void>();
  searchText: string = '';
  solicitudesOriginales: Solicitud[] = [];
  solicitudes: Solicitud[] = [];
  generarExcel: boolean = false;
  loading : boolean = false;
  usuarioSeleccionado ?: string | null;
  NoAcceso: boolean = false;
  mi_info: boolean = false;

  ngOnInit(): void {
    this.getUser();
  }

  getUser() {
    this.sessionStore.getPerfil()
    .pipe(takeUntil(this.$onDestroy))
    .subscribe((user:Usuario | null) => {
      this.user = user;
      if(!this.user?.esRRHH && !this.user?.esColaborador && !this.user?.esAdmin && !this.user?.esMedico){
        this.$onDestroy.next();
        this.$onDestroy.complete();
        this.sessionStore.clearPerfil();
        this.router.navigate(['/']);
      }
      else {
        this.obtenerData();
        this.obtenerPeriodo();
      }
    });
  }

  ngOnDestroy() {
    this.$onDestroy.next();
    this.$onDestroy.complete();
  }

   async obtenerPeriodo() {
      try {
        let ResPeriodos = await lastValueFrom(this.catalogos.obtenerCatalogoCalendario());
        if (ResPeriodos?.details && Array.isArray(ResPeriodos.details)) {
          this.evaluarAccesoPorFecha(ResPeriodos.details);
        }
      } catch (error) {
        this.NoAcceso = true;
      }
    }

  evaluarAccesoPorFecha(periodos: any[]) {
    const fechaActual = new Date();
    const mesActual = fechaActual.getMonth() + 1;
    const añoActual = fechaActual.getFullYear();
    if(mesActual === 1 ) {
      this.NoAcceso = fechaActual > new Date('01/24/' + añoActual);
    }
    else if (mesActual >= 2 && mesActual <= 12) {
      const fechaLimite = new Date(periodos.find(periodo => 
        periodo.mesContable?.toLowerCase() === 'diciembre'
      )?.limiteInfoColaborador || '12/10/' + añoActual);
      if (fechaLimite) {
        this.NoAcceso = fechaActual < fechaLimite;
      } else {
        this.NoAcceso = false;
      }
    } else {
      this.NoAcceso = false;
    }
  }

  obtenerData() {
    let ListadoService = (this.user?.esColaborador || this.user?.esMedico || this.mi_info) ? this.obtenerSolicitudesColaborador() : this.obtenerListaSolicitudes();
    this.loading = true;
    ListadoService
    .pipe(
      takeUntil(this.$onDestroy),
      finalize(() => {
        this.loading = false;
        this.cdr.detectChanges();
      })
    )
    .subscribe({
      next: (res) => {
        let data = res?.details as Solicitud[];
        this.solicitudes = [...data];
        this.solicitudesOriginales = [...this.solicitudes];
      },
      error: (error) => {
        console.error('Error al obtener las solicitudes:', error);
      }
    });
  }

  obtenerListaSolicitudes() {
    return this.gestionSgmmService.obtenerListado()
  }

  obtenerSolicitudesColaborador() {
    return this.gestionSgmmService.obtenerListadoColaborador(this.user?.colaboradorId!)
  }



  onSearchChange(searchValue: string): void {
    if (!searchValue || searchValue.trim() === '') {
      this.solicitudes = [...this.solicitudesOriginales];
      return;
    }

    const searchTerm = searchValue.toLowerCase().trim();
    
    this.solicitudes = this.solicitudesOriginales.filter(solicitud => {
      const colaboradorNombreCompleto = `${solicitud.colaboradorNombres || ''} ${solicitud.colaboradorApellidos || ''}`.toLowerCase();
      const beneficiarioNombre = (solicitud.beneficiarioNombresApellidos || '').toLowerCase();
      const id = solicitud.id?.toString() || '';
      const colaboradorId = solicitud.colaboradorId?.toString() || '';
      const estatus = (solicitud.estatusNombre || '').toLowerCase();
      
      return colaboradorNombreCompleto.includes(searchTerm) ||
             beneficiarioNombre.includes(searchTerm) ||
             id.includes(searchTerm) ||
             colaboradorId.includes(searchTerm) ||
             estatus.includes(searchTerm);
    });
  }

  onAccionClick(data : Solicitud): void {
    const drawer = this.drawerService.create({
      nzContent: DetalleSolicitudComponent,
      nzWidth: 720,
      nzPlacement: 'right',
      nzContentParams: {
        solicitud: data
      },
    });
    drawer.afterClose.subscribe({
      next: (res: any) => {
        if (res) {
        }
      },
    });
  }


  getEstatusColor(estatus: string | null | undefined): string {
    switch(estatus?.toLowerCase()) {
      case 'autorizado':
      case 'aprobado':
        return '#00A226';
      case 'rechazado':
        return '#E31F42';
      case 'en revisión':
      case 'en revision':
      case 'proceso':
        return '#FFC01A';
      case 'pendiente':
        return '#FFC01A';
      case 'pagado':
        return '#00A226';
      default:
        return '#0234D7';
    }
  }

  getEstatusIcon(estatus: string | null | undefined): string {
    switch(estatus?.toLowerCase()) {
      case 'autorizado':
      case 'aprobado':
      case 'pagado':
        return 'assets/icon/success.svg';
      case 'rechazado':
        return 'assets/icon/refuse.svg';
      case 'en revisión':
      case 'en revision':
      case 'pendiente':
      case 'proceso':
      default:
        return 'assets/icon/process.svg';
    }
  }

  shouldUseBlackText(estatus: string | null | undefined): boolean {
    switch(estatus?.toLowerCase()) {
      case 'pendiente':
        return true;
      default:
        return false;
    }
  }


  AddSolicitud(){
    const drawer = this.drawerService.create({
      nzContent: EnvioSolicitudesComponent,
      nzWidth: 720,
      nzPlacement: 'right',
      nzContentParams: {
        
      },
    });
    drawer.afterClose.subscribe({
      next: (res: any) => {
        if (res) {
          this.obtenerData();
        }
      },
    });

  }

  descargarExcel() {
    this.generarExcel = true;
    this.gestionSgmmService.descargarExcel({})
    .pipe(
      finalize(
        ()=>{
          this.generarExcel = false;
        }
      )
    )
    .subscribe({
      next: (res: any) => {
        try {
          if (res) {
            let blob: Blob;
            if (res instanceof Blob) {
              blob = res;
            } else {
              blob = new Blob([res], { 
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
              });
            }
            
            const fecha = new Date();
            const fechaString = fecha.toISOString().split('T')[0];
            const nombreArchivo = `Reporte_Solicitudes_SGMM_${fechaString}.xlsx`;            
            saveAs(blob, nombreArchivo);
          } else {
            console.error('La respuesta del servidor está vacía');
          }
        } catch (error) {
          console.error('Error al procesar la descarga del Excel:', error);
        }
      },
      error: (error) => {
        console.error('Error al generar Excel:', error);
      }
    });
  }

}
